import React, { useState, useEffect } from "react";
import { Box, Heading, Button, Layer, Text } from "grommet";
import { Close } from "grommet-icons";
import dashboard from "../../assets/pursuit/dashboard.png";
import userSelfAssessments from "../../assets/pursuit/user-self-assessments.png";
import userRecommendation from "../../assets/pursuit/user-recommendation.png";
import managerAssessments from "../../assets/pursuit/manager-assessments.png";
import managerAssessmentRecommendation from "../../assets/pursuit/manager-assessment-recommendation.png";
import requests from "../../assets/pursuit/dedicated-requests.png"

const slides = [
  {
    text: "Welcome to the HPE Digital Skill Advisor! In the Pursuit Access portal, you can explore user self-assessments, manager-created assessments, and dedicated requests; drill into any user’s full assessment history; view tailored recommendations for users in manager-created assessments; and export all details with a single click.",
    image: dashboard,
  },
  {
    text: "User Self Assessments shows every assessment created and taken by users themselves. Use search (name, email, country, date) and filters (date range up to 6 months, user type, region, communicate/mark all) to narrow results. For each entry you can see if the user is contactable, the assessment date, user name/email, country, user type, any comment, and whether/when they were contacted. Use the Actions to open User Details, mark the user as contacted, and add/edit comments. You can Export the list or switch to Manager Created Assessments. Click Next to learn how recommendations work.",
    image: userSelfAssessments,
  },
  {
    text: "Recommendations for assessments shows course recommendations for the selected assessment. Under ‘Skills assessed on’ you’ll see the Product name, Skill name, and a Course recommendation—click View to open the curated courses for the selected assessment. Use Export to download all assessments details for a selected timeframe, or open View Assessment Overview and View Assessment Questions for context. Need history? Click Show Other Assessments to view this user’s past assessments.",
    image: userRecommendation,
  },
  {
    text: "Manager Created Assessments lists all assessments set up by managers. Use search (assessment name, manager, topic, or country) and filters (date range up to 6 months, region) to narrow results. For each assessment you can see when it was created, total users, how many completed, manager name/email/country, last contact status/time, and a comment preview. Use Actions to open Manager & Users, view recommendations, mark the manager as contacted, and add/edit comments. You can Export the table or switch to User Self Assessments.",
    image: managerAssessments,
  },
  {
    text: "Recommendations by User shows assessment details and skills, plus all assigned users. For each user you can see name, email, status, end time, and their recommended courses directly. Click ‘View recommendations’ for an in-depth recommendation. Use ‘Export assessment data’ to download everything.",
    image: managerAssessmentRecommendation,
  },
  {
    text: "Dedicated Learning Requests lists all user submissions for tailored support. Search by name, country, or email. Each row shows the request date, name, email, country, and support needed. Use the Actions column to View details for more information about the request, or click the email icon to contact the requester directly.",
    image: requests,
  },
  {
    text: "Once again, welcome to HPE Digital Skill Advisor! Reach out to hpeskill.advisor@hpe.com for help.",
    image: dashboard,
  },
];

const DashboardTourModal = ({ showModal, setShowModal }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (showModal) {
      setCurrentSlide(0);
    }
  }, [showModal]);

  return (
    showModal && (
      <Layer
        onEsc={() => setShowModal(false)}
        onClickOutside={() => setShowModal(false)}
        responsive={false}
      >
        <Box
          width="80vw" // Set width to 80% of the viewport width
          height="auto"
          pad={{ top: "medium", horizontal: "xsmall" }}
          round="small"
          overflow="auto"
          alignSelf="center"
        >
          <Box
            direction="row"
            align="center"
            margin={{ bottom: "small" }}
            justify="between"
          >
            {/* Step Indicator on the left */}
            <Text size="medium" margin={{ left: "small" }}>
              {`Step ${currentSlide + 1} of ${slides.length}`}
            </Text>

            {/* Title in the center */}
            <Heading
              level={2}
              margin={{ vertical: "none", right: "none", left: "105px" }}
              alignSelf="center"
              textAlign="center" // Center the text
              style={{ flexGrow: 1, display: "flex", justifyContent: "center" }} // Ensure the title is horizontally centered
            >
              HPE Digital Skill Advisor Pursuit Access Tour
            </Heading>

            {/* Close Button on the right */}
            <Button
              icon={<Close />}
              margin={{ right: "small" }}
              onClick={() => setShowModal(false)}
              plain
              style={{ marginLeft: "auto" }}
            />
          </Box>

          <Box align="center" pad="small" flex="grow" width="100%">
            <img
              src={slides[currentSlide].image}
              alt="Slide Image"
              style={{
                maxWidth: "100%", // Make image take up the full width of the container
                maxHeight: "70vh", // Limit height for readability, but still larger
                objectFit: "contain", // Ensure the image maintains its aspect ratio and fits within the box
              }}
            />
            <Text textAlign="center" margin={{ top: "small" }} size="medium">
              {slides[currentSlide].text}
            </Text>
          </Box>
        </Box>
        <Box pad={{ bottom: "small", horizontal: "medium" }}>
          <Box
            direction="row"
            justify="end"
            margin={{ top: "small" }}
            width="100%"
          >
            {currentSlide > 0 && (
              <Button
                label="Previous"
                onClick={() => setCurrentSlide(currentSlide - 1)}
                secondary
              />
            )}
            {currentSlide < slides.length - 1 ? (
              <Button
                label="Next"
                onClick={() => setCurrentSlide(currentSlide + 1)}
                primary
                margin={{ left: "medium" }}
              />
            ) : (
              <Button
                label="Close"
                onClick={() => setShowModal(false)}
                primary
                margin={{ left: "medium" }}
              />
            )}
          </Box>
        </Box>
      </Layer>
    )
  );
};

export default DashboardTourModal;
